import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import TableBody from "@mui/material/TableBody";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TextField from "@mui/material/TextField";
import TableContainer from "@mui/material/TableContainer";
import React, {useRef, useState} from "react";
import {v4} from "uuid";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Dialog from "@mui/material/Dialog";
import CreateIcon from "@mui/icons-material/Create";
import AddIcon from "@mui/icons-material/Add";
import {ICharDiary} from "../../_interfaces/ICharDiary";
import {useSignals} from "@preact/signals-react/runtime";
import {s_char, s_char_diary} from "../../_signals/s_char";
import {DiaryCreate, DiaryDelete, DiaryUpdate} from "../../_api/BEDiary";
import {date2Ger, date2Timestamp} from "../../_helper/dates";

function Diary() {
    useSignals()

    const [open, setOpen] = useState(false)
    const [edit, setEdit] = useState(false)
    const [diary, setDiary] = useState<ICharDiary | null>(null)
    const entryRef = useRef<HTMLInputElement | null>(null);
    const [filter, setFilter] = useState('');


    const diaryRow = (row: ICharDiary) => {
        let date = new Date(row.ts);
        return <TableRow key={row.id} style={{
            display: filter ? row.entry.toLowerCase().includes(filter.toLowerCase()) ? 'table-row' : 'none' : 'table-row'
        }}>
            <TableCell style={{width: '15%'}}>{date2Ger(date)}</TableCell>
            <TableCell style={{width: '84%'}}>
                {row.entry}
            </TableCell>
            <TableCell style={{width: '1%', paddingRight: 0}}>
                <Button className={'btn'} id="post" onClick={() => openEdit(row)}>
                    <CreateIcon/>
                </Button>
            </TableCell>
        </TableRow>
    }

    const save = () => {
        if (!entryRef.current) return;

        let diaryValue = s_char_diary.value;

        if (!edit) {
            if (entryRef.current && entryRef.current.value !== '') {
                let addDiary = diary;
                if (addDiary) {
                    addDiary.entry = entryRef.current.value
                    DiaryCreate(addDiary);
                    diaryValue.unshift(addDiary);
                    s_char_diary.value = diaryValue
                }
            }
        } else {
            const foundIndex = diaryValue.findIndex(x => x.id === diary?.id);
            if (foundIndex >= 0 && entryRef.current) {
                diaryValue[foundIndex].entry = entryRef.current.value;
                DiaryUpdate(diaryValue[foundIndex])
                s_char_diary.value = diaryValue
            }
        }

        setDiary(null)
        setOpen(false)
    }

    const cancel = () => {
        setDiary(null)
        setOpen(false)
    }

    const openEdit = (diary: ICharDiary) => {
        setDiary(diary)
        setEdit(true)
        setOpen(true);
    }

    const add = () => {
        const now = new Date()

        const addDiary: ICharDiary = {
            id: v4(),
            cid: s_char.value.id,
            ts: date2Timestamp(now),
            entry: ''
        }
        setDiary(addDiary)
        setOpen(true);
    }

    const remove = () => {
        if (!diary) return
        let diaryValue = s_char_diary.value;
        const f = diaryValue.findIndex(x => x.id === diary?.id);
        if (f >= 0) {
            diaryValue.splice(f, 1);
            s_char_diary.value = diaryValue
            DiaryDelete(diary)

            setDiary(null)
            setOpen(false)
        }
    }

    return <Paper style={{overflowX: 'auto', marginTop: "14px"}}>
        <h3 style={{margin: "5px", display: 'flex', justifyContent: 'space-between'}}>
            <span>Tagebuch</span>
            <TextField size={'small'}
                       style={{marginLeft:'auto',marginRight:10}}
                       defaultValue={''}
                       label={'suche'}
                       value={filter}
                       onChange={(e) => setFilter(e.target.value)}
            >
            </TextField>
            <AddIcon onClick={() => add()}/>
        </h3>

        <TableContainer style={{maxHeight: 185}}>
            <Table stickyHeader style={{width: '100%'}} size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>Wann</TableCell>
                        <TableCell>Was</TableCell>
                        <TableCell></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>{s_char_diary.value.map((row) => diaryRow(row))}</TableBody>
            </Table>
        </TableContainer>
        <Dialog open={open}>
            <DialogContent>
                <TextField defaultValue={diary?.entry}
                           inputRef={entryRef}
                           variant="standard"
                           style={{width: '100%'}}
                />
            </DialogContent>
            <DialogActions>
                <Button className={'btn'} id="post" onClick={() => save()}><CheckIcon/></Button>
                <Button className={'btn'} id="post" onClick={() => cancel()}><ClearIcon/></Button>
                <Button className={'btn'} id="post" onClick={() => remove()}>
                    <DeleteOutlineIcon/>
                </Button>
            </DialogActions>
        </Dialog>
    </Paper>

}

export default Diary;
